import type { HTMLAttributes } from 'react';
import { clsx } from '../clsx';
import styles from './Caret.module.css';

export interface CaretProps extends HTMLAttributes<HTMLSpanElement> {
  /** 9 px in the topbar triggers, 10 px in compact selects, 11 px in form fields (the screens' `▾`). */
  size?: 9 | 10 | 11 | undefined;
}

/** The `▾` glyph the screens use as dropdown and select indicator (a text glyph, not an icon). */
export function Caret({ size = 11, className, ...rest }: CaretProps) {
  return (
    <span aria-hidden="true" className={clsx(styles.caret, className)} style={{ fontSize: size }} {...rest}>
      ▾
    </span>
  );
}
